import { SVGIconComponent } from './types';

/**
 * MUI's `Emergency` icon (a six-pointed asterisk), inlined: it only exists in `@mui/icons-material`
 * (v5) and this app is on `@material-ui/icons` v4, which has no equivalent. Inlined rather than
 * pulled in as a dependency, and shaped as an `SVGIconComponent` so it fills with `currentColor` —
 * a MUI icon's own `color` prop takes a palette variant ('primary', 'action', …) rather than the
 * CSS colour `MultipleSVGCell` passes.
 */
export const Emergency: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, ...style }}
    className={className}
  >
    <path
      fill="currentColor"
      d="m20.79 9.23-2-3.46L14 8.54V3h-4v5.54L5.21 5.77l-2 3.46L8 12l-4.79 2.77 2 3.46L10 15.46V21h4v-5.54l4.79 2.77 2-3.46L16 12z"
    />
  </svg>
);
